import React from 'react'
import {TwChatMessageBottom} from '../chat-message/containers'
import {
  TwChatSystemMessage,
  TwChatSystemMessageContainer,
  TwDateTime,
  TwIcon,
  TwMessage
} from './containers'
import {ChatSystemMessageProps} from './types'
import {getIconColor} from './utils'

export const ChatSystemMessage = ({
  type,
  layout = 'horizontal',
  html,
  content,
  dateTime,
  icon,
  className,
  animateShow,
  timestamp,
  additionalDevInfo
}: ChatSystemMessageProps) => (
  <TwChatSystemMessageContainer
    $animateShow={animateShow}
    className={className}
    data-message-timestamp={timestamp}
    data-additional-dev-info={additionalDevInfo}
  >
    <TwChatSystemMessage $type={type} $layout={layout}>
      {icon && <TwIcon icon={icon} color={getIconColor(type)} />}
      <TwMessage dangerouslySetInnerHTML={html ? {__html: html} : undefined}>
        {content}
      </TwMessage>
      {dateTime && <TwDateTime $layout={layout}>{dateTime}</TwDateTime>}
    </TwChatSystemMessage>
    <TwChatMessageBottom />
  </TwChatSystemMessageContainer>
)
